<template>
  <div id="download-btn-box">
    <div v-show="currentPlatform === 'windows'" class="content" id="windows">
      <router-link
        :to="!$store.state.hasToken ? '/register' : '/dashboard'"
        class="get-plex"
        >{{ $t("getPlex") }}</router-link>
      <div class="gradient-download-btn">
        <a :href="windows.downloadInfo.download_link" @click="trackDownload(windows.platform, windows.name)">{{ $t('downloadNow') }}</a>
      </div>
    </div>

    <div v-show="currentPlatform === 'mac' || currentPlatform === 'ubuntu'" class="content">
      <router-link
        :to="!$store.state.hasToken ? '/register' : '/dashboard'"
        class="get-plex"
        >{{ $t("getPlex") }}</router-link>
      <div class="gradient-download-btn">
        <a :href="currentDownloadInfo.downloadInfo.download_link"
           @click="trackDownload(currentDownloadInfo.platform, currentDownloadInfo.name)">
          {{ $t('downloadNow') }}
        </a>
      </div>
    </div>

    <div v-show="currentPlatform === 'ios'" class="content">
      <router-link
        :to="!$store.state.hasToken ? '/register' : '/dashboard'"
        class="get-plex"
        >{{ $t("getPlex") }}</router-link>
      <div class="gradient-download-btn">
        <a :href="currentDownloadInfo.downloadInfo.download_link" target="_blank"
           @click="trackDownload(currentDownloadInfo.platform, currentDownloadInfo.name)">
          {{ $t('downloadNow') }}
        </a>
      </div>
    </div>

    <div v-show="currentPlatform === 'android'" class="content" id="android">
      <div>
        <router-link
          :to="!$store.state.hasToken ? '/register' : '/dashboard'"
          class="get-plex"
          >{{ $t("getPlex") }}</router-link>
        <div class="gradient-download-btn">
          <a :href="currentDownloadInfo.downloadInfo.download_link"
            @click="trackDownload(currentDownloadInfo.platform, currentDownloadInfo.name)">{{ $t('downloadNow') }}</a>
        </div>
        <div class="qrcode-link">
          <img src="/static/img/downloadNew/ic_qr.svg" alt="下载PlexVPN安卓客户端" class="little-qrcode">
          <qr-code :text="currentDownloadInfo.downloadInfo.download_link" :size=160 class="qrcode"></qr-code>
        </div>
      </div>
      <div class="gradient-download-btn">
        <a href="https://play.google.com/store/apps/details?id=com.shoplex.plex" target="_blank"
           @click="trackDownload(currentDownloadInfo.platform, currentDownloadInfo.name)">
          Google Play
        </a>
      </div>
    </div>

    <div v-show="currentPlatform === 'androidTV'" class="content">
      <router-link
        :to="!$store.state.hasToken ? '/register' : '/dashboard'"
        class="get-plex"
        >{{ $t("getPlex") }}</router-link>
      <div class="gradient-download-btn">
        <a :href="currentDownloadInfo.downloadInfo.download_link"
            @click="trackDownload(currentDownloadInfo.platform, currentDownloadInfo.name)">{{ $t('downloadNow') }}</a>
      </div>
    </div>

    <other-version></other-version>

  </div>
</template>

<script>
  import OtherVersion from '../downloadOtherVersion/DownloadOtherVersion.vue'
  import QrCode from '../../../components/QrCode.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'download-btn',
    components: {
      QrCode,
      OtherVersion
    },
    props: {
      phoneBottom: {type: Boolean, default: false}
    },
    computed: {
      currentDownloadInfo() {
        return this.$store.state.download[this.currentPlatform]
      },
      ...mapState({
        currentPlatform: state => state.download.currentPlatform,
        windows: state => state.download.windows
      })
    },
    locales: {
      zh: {
        download: '下载',
        downloadApk: '下载安装包',
        downloadNow: '立即下载',
        getPlex: "获取 PlexVPN"
      },
      en: {
        download: 'Download',
        downloadApk: 'Download APK',
        downloadNow: 'Download App',
        getPlex: "Get PlexVPN"
      }
    },
    methods: {
      trackDownload(platform, version) {
        this.$ga.event('Download Application', platform, version)
        // Event snippet for downloadClient page
        window.dataLayer && window.dataLayer.push({'event': 'download_' + platform})
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/mixins/gradient";
  @import "../../../assets/scss/mixins/button";

  * {
    padding: 0;
    margin: 0;
  }

  #download-btn-box {
    width: 100%;
  }

  .content {
    display: flex;
  }

  .get-plex {
    display: inline-block;
    margin-top: .16rem;
    width: 240px;
    height: 66px;
    line-height: 66px;
    font-size: 24px;
    color: #ffffff;
    text-align: center;
    font-weight: 600;
    background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
    border-radius: 100px;
  }

  .gradient-download-btn {
    margin: .16rem 0 0 .4rem;
    text-align: center;
    width: 238px;
    height: 64px;
    line-height: 64px;
    font-size: 24px;
    font-weight: 600;
    position: relative;
    border-radius: 100px;
    background: url('/static/img/downloadNew/pc_btn_bg.png');
    background-clip: padding-box; /*important*/
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      z-index: -1;
      margin: -1px;
      border-radius: inherit; /*important*/
      background: linear-gradient(90deg, #416CF8, #EC55FF);
    }
    a {
      background: -webkit-linear-gradient(0deg, #416CF8, #EC55FF);
      -webkit-text-fill-color: transparent;
      -webkit-background-clip: text;
      display: block;
    }
  }

  #android {
    display: block;
    > div:first-child {
      display: flex;
    }
    > .gradient-download-btn {
      margin: .24rem 0 0;
    }
    .qrcode-link {
      position: relative;
      top: 0;
      left: 0;
    }
  }

  @media screen and (min-width: 768px) {
    .qrcode-link {
      display: inline-block;
      margin: .16rem 0 0 .4rem;
      line-height: 66px;
    }
    .qrcode-link {
      .little-qrcode {
        height: .36rem;
      }
      .qrcode {
        position: absolute;
        display: none;
        z-index: 1;
        top: 50%;
        right: -1.7rem;
        margin-top: -.83rem;
      }
      &:hover, &:active {
        .qrcode {
          display: inline-block;
        }
      }
    }
  }
  
  @media screen and (max-width: 820px) {
    .qrcode-link .qrcode {
      transform: scale(.8);
      right: -1.5rem;
    }
  }

  @media screen and (max-width: 767px) {
    #download-btn-box {
      overflow: hidden;
    }
    .content {
      max-width: calc(100vw - .4rem);
      margin-top: 0.16rem;
      text-align: center;
      display: block;
    }
    .get-plex {
      display: block;
      width: 260px;
      height: 49px;
      line-height: 49px;
      font-size: 16px;
      margin: 0 auto;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 4px;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
        border-radius: 100px;
        filter: blur(4px);
        -webkit-filter: blur(4px);
        -moz-filter: blur(4px);
        -ms-filter: blur(4px);
        -o-filter: blur(4px);
        z-index: -1;
      }
    }
    .gradient-download-btn {
      display: block;
      width: 258px;
      height: 47px;
      line-height: 47px;
      font-size: 16px;
      margin: 24px auto 1px;
      background: url('/static/img/downloadNew/h5_btn_bg.png');
    }
    #android {
      > div:first-child {
        display: block;
      }
      > .gradient-download-btn {
        margin: 0.24rem auto 1px;
      }
    }
    .qrcode-link {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// DownloadBtn.vue?394e6274